import React from "react";
import { connect } from "react-redux";
import language from "../../../language";
import { Table } from "../../Table";
import { Modal, DeleteModal } from "../../Modal";
import { CSVLink } from "react-csv";
import exportPDF from "../../../utils/exportPDF";
import NeNewTestHistoryAccount from "./NewTest";
import { defineRole } from "../../../utils/handleAccessRoles";
import { getStorage } from "../../../utils/storage";
import icons from "../../../constants/icons";
import { ROLE_BLOOD_TEST_SEROLOGY } from "../../../constants/ROLES";
import {
  deleteBloodTestHistory,
  fetchBloodTestHistory,
} from "../../../utils/queries/bloodTestHistory";
import accessMenu from "../../../utils/accessMenu";

// eslint-disable-next-line no-unused-vars
let copyData = [];
// eslint-disable-next-line no-unused-vars

class Serology extends React.Component {
  csvDownload = React.createRef();

  state = {
    isLoading: false,
    data: [],
    page: 1,
    limit: 10,
    search_text: "",
    selectedData: {},
    totalPageCount: 10,
    delete_password: "",
    delete_value: "",
    error: {},
    csvData: [],
    user: {},
  };

  componentDidMount = async () => {
    const user = await getStorage();
    this.setState({ user });

    await this.getData(true);

    this.handleCountAddEnableAdd();
  };

  onChangeText(field, e) {
    let { error } = this.state;

    delete error[field];

    this.setState({ error, [field]: e?.target?.value });
  }

  getData = async (isLoading, search = {}) => {
    try {
      const { page, limit } = this.state;
      const { defaultLanguage, testId } = this.props;
// eslint-disable-next-line no-unused-vars
      const { canConfirmBloodTestSerology } = accessMenu();
// eslint-disable-next-line no-unused-vars
      const user = await getStorage();

      this.setState({ isLoading, canConfirm: canConfirmBloodTestSerology });

      const { data, count, totalRecords } = await fetchBloodTestHistory(defaultLanguage, {
        page,
        limit,
        bloodTest: testId,
        questionnaireType: "serology",
        // testBy: !canConfirmBloodTestSerology ? user.id : undefined,
        ...search,
      });

      this.setState(
        {
          data,
          totalPageCount: count,
        totalRecords,
          isLoading: false,
        },
        () => {
          this.handleCountAddEnableAdd();
        }
      );

      copyData = data.slice(0);
    } catch (error) {
      this.setState({
        isLoading: false,
      });
    }
  };

  handlePagination(page, _tab, limit) {
    this.setState(
      {
        page,
        ...(limit != null && { limit }),
      },
      () => {
        this.getData(true);
      }
    );
  }

  handleLimitChange(limit) {
    this.setState({ limit, page: 1 }, () => {
      this.getData(true);
    });
  }

  handleShowModal(modal, modalTitle, selectedData = {}) {
    this.setState({
      [modal]: true,
      modalTitle: modalTitle,
      selectedData,
    });
  }

  /**
   * When user clicks "Add", if there's an existing ALLINITY record (instrument
   * data that was pushed automatically), open that record in edit mode so the
   * user updates it rather than creating a duplicate.
   */
  handleAddSerology = () => {
    const allinityRecord = this.state.data.find(
      (el) =>
        el?.sampleCollectionMethod === "alinity" &&
        el.status !== "cancelled",
    );

    // The analyser's row is opened to prefill what it already reported, so
    // the manual Syphilis and HCV results are entered beside it. Saving
    // writes a row of its own rather than overwriting the analyser's -
    // isManualEntry is what tells the form which of the two it is doing.
    this.handleShowModal("showModal", language[this.props.defaultLanguage].add, {
      ...(allinityRecord || {}),
      isManualEntry: true,
      existingCodes: this.state.data.map((el) => el.code).filter(Boolean),
    });
  };

  handleCloseModal(modal) {
    this.setState({
      [modal]: false,
    });
  }

  returnTableHeaders() {
    let headers = [
      {
        title: language[this.props.defaultLanguage].code,
        key: "code",
        type: "link",
        onPress: (item) =>
          this.handleShowModal("showModal", "NO:" + item.code, item),
        styles: {
          textTransform: "uppercase",
        },
      },
      {
        title: language[this.props.defaultLanguage].tested_by,
        key: "testBy.name",
         fallbackKeys: ["operator.name", "operator.type"],
      },
      {
        title: language[this.props.defaultLanguage].stage,
        key: "stage",
        type: "status",
      },
      {
        title: language[this.props.defaultLanguage].method,
        key: "sampleCollectionMethod",
        type: "status",
      },

      {
        title: language[this.props.defaultLanguage].status,
        key: "status",
        type: "status",
      },
      {
        title: language[this.props.defaultLanguage].date,
        key: "createdAt",
        formatTime: "lll",
        isMoment: true,
      },
      {
        title: language[this.props.defaultLanguage].actions,
        key: "action",
      },
    ].filter(Boolean);

    return headers;
  }

  onDelete = async () => {
    try {
      this.setState({ isDeleting: true });

      await deleteBloodTestHistory(this.props.defaultLanguage, {
        id: this.state.selectedData._id,
        bloodTest:
          this.state.selectedData.bloodTest?._id ||
          this.state.selectedData.bloodTest,
      });

      this.setState({ isDeleting: false });

      this.getData(true);
      this.handleCloseModal("showDeleteModal");
    } catch (error) {
      console.log(error);
      this.setState({
        isDeleting: false,
      });
    }
  };

  downloadExcel = async () => {
    try {
      this.setState({
        isLoading: true,
      });

      const { page, limit } = this.state;
      const { defaultLanguage } = this.props;

      const { data } = await fetchBloodTestHistory(defaultLanguage, {
        page,
        limit,
        bloodTest: this.props.testId,
        questionnaireType: "serology",
      });

      this.setState({
        isLoading: false,
        csvData: data,
      });

      this.csvDownload.current?.link.click();
    } catch (error) {
      this.setState({
        isLoading: false,
      });
    }
  };

  downloadPDF = async () => {
    this.setState({
      isLoading: true,
    });

    const { page, limit } = this.state;
    const { defaultLanguage } = this.props;

    const headers = this.returnTableHeaders();

    const { data } = await fetchBloodTestHistory(defaultLanguage, {
      page,
      limit,
      bloodTest: this.props.testId,
      questionnaireType: "serology",
    });

    this.setState({
      isLoading: false,
    });

    exportPDF("Serology", headers, data);
  };

  handleRemoteSearch = async (search) => {
    await new Promise((r) => this.setState({ searching: true, page: 1 }, r));

    await this.getData(true, {
      code: search || search !== "" ? search : undefined,
    });

    this.setState({
      searching: false,
    });
  };

  handleSearch = async (e) => {
    const search = e?.target?.value;
    this.setState({ search_text: search });
  };

  handleCountAddEnableAdd = () => {
    const { data, user } = this.state;

    let count = 0,
      total = 0,
      isEnabledAdd = false;

    for (let el of data) {
      if (el.status !== "cancelled") {
        if (el?.testBy?._id === user.id) {
          count += 1;
        }

        total += 1;
      }
    }

    if (count > 0 || total === 2) {
      isEnabledAdd = false;
    } else {
      isEnabledAdd = total < 2;
    }

    this.setState({
      isEnabledAdd,
    });
  };

  render() {
    const { export_, edit, delete_ } = language[this.props.defaultLanguage];

    const canAccessCreateBloodTest_serology = defineRole({
      roles: this.state.user.accessRole,
      menu: ROLE_BLOOD_TEST_SEROLOGY,
      operation: "create",
    });

    return (
      <>
        {this.state?.data?.[0]?.bloodTest?.donation?.blockInfo?.blocked && (
          <div className="alert alert-danger">
            <h3>{language[this.props.defaultLanguage].blocked_donation}</h3>
            <p>
              {language[this.props.defaultLanguage].reason}:{" "}
              {this.state?.data[0]?.bloodTest?.donation?.blockInfo?.blockReason}
            </p>
          </div>
        )}
        <Table
          data={this.state.data}
          isSearch={false}
          page={this.state.page}
          limit={this.state.limit}
          search_text={this.state.search_text}
          addSearchButton
          searching={this.state.searching}
          handlePressSearch={() =>
            this.handleRemoteSearch(this.state.search_text)
          }
          handleSearch={this.handleSearch.bind(this)}
          totalPageCount={this.state.totalPageCount}
          totalRecords={this.state.totalRecords}
          isLoading={this.state.isLoading}
          handlePagination={this.handlePagination.bind(this)}
          onLimitChange={this.handleLimitChange.bind(this)}
          headers={this.returnTableHeaders()}
          showAdd={this.state.isEnabledAdd && canAccessCreateBloodTest_serology}
          addButtonText={language[this.props.defaultLanguage].add}
          handleAddPressed={this.handleAddSerology.bind(this)}
          rowPress={(item) =>
            this.state.canConfirm
              ? this.handleShowModal("showModal", item.name, item)
              : null
          }
          filters={[
            {
              type: "export",
              title: export_,
              button_type: "dropdown",
              icon: "bx bxs-download",
              options: [
                {
                  name: "PDF",
                  onPress: this.downloadPDF.bind(this),
                },
                {
                  name: "CSV",
                  onPress: this.downloadExcel.bind(this),
                },
              ],
            },
          ]}
          actions={[
            {
              canAccess: defineRole({
                roles: this.state.user.accessRole,
                menu: ROLE_BLOOD_TEST_SEROLOGY,
                operation: "update",
              }),
              icon: icons.edit,
              name: edit,
              onPress: (item) =>
                this.handleShowModal(
                  "showModal",
                  language[this.props.defaultLanguage].edit,
                  item
                ),
            },
            {
              canAccess: defineRole({
                roles: this.state.user.accessRole,
                menu: ROLE_BLOOD_TEST_SEROLOGY,
                operation: "delete",
              }),
              icon: icons.delete,
              name: delete_,
              onPress: this.handleShowModal.bind(
                this,
                "showDeleteModal",
                language[this.props.defaultLanguage].delete_
              ),
            },
          ]}
        />

        <Modal
          handleClose={this.handleCloseModal.bind(this, "showModal")}
          show={this.state.showModal}
          title={this.state.modalTitle}
          showHeaderBottomBorder={false}
          size="lg"
        >
          <NeNewTestHistoryAccount
            key={this.state.selectedData?._id || "serology-new"}
            handleCloseModal={this.handleCloseModal.bind(this, "showModal")}
            getData={this.getData.bind(this)}
            {...this.state.selectedData}
            testId={this.props.testId}
            canConfirm={this.state.data.length >= 1}
            previousTestResults={
              !this.state?.selectedData?._id ? this.state.data : []
            }
          />
        </Modal>

        <Modal
          handleClose={this.handleCloseModal.bind(this, "showDeleteModal")}
          show={this.state.showDeleteModal}
          title={this.state.modalTitle}
        >
          <DeleteModal
            handleCloseModal={this.handleCloseModal.bind(
              this,
              "showDeleteModal"
            )}
            error={this.state.error.delete_password}
            value={this.state.delete_value}
            onDelete={this.onDelete.bind(this)}
            onChange={(e) => this.onChangeText("delete_value", e)}
            isDeleting={this.state.isDeleting}
            name={this.state.selectedData.name}
            getData={this.getData.bind(this)}
          />
        </Modal>
        <CSVLink
          ref={this.csvDownload}
          filename={"Serology" + new Date().getTime()}
          data={this.state.csvData}
        ></CSVLink>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(Serology);
